//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfileData from '~/components/profile/mixins/ProfileData'
import ProfileMixinDestinations from "~/components/profile/mixins/ProfileMixinDestinations"

import { BModal, BButton, BFormSelect, BFormSelectOption } from 'bootstrap-vue'

export default {

    name: 'PartialDestinations',

    mixins: [ProfileData, ProfileMixinDestinations],

    components: { BModal, BButton, BFormSelect, BFormSelectOption },

    props: {
        company: {
        },
        spinner: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            visible: true,
            isReady: false,
            modalShowFiles: false,
            files: [],
            showEntriesInit: 4,
            destinationsShowed: 0,
            destinationSelected: 'all',
        }
    },

    mounted() {
        this.destinationsShowed = this.showEntriesInit - 1
    },

    methods: {

        openGallery(id) {
            this.$bus.$emit('openDestinationGallery', id)
        },

        async openModalFiles(id) {

            try {
                const response = await this.$store.dispatch('profile/GET_DESTINATION_FILES', id)
                this.files = response.data
                this.modalShowFiles = true
            } catch (e) {
                this.$logger.captureException(e)
            }

        },

        loadMoreDestinations() {
            this.destinationsShowed += this.showEntriesInit
        },

        showDestinationEntry(index, id) {

            if(this.destinationSelected === 'all') {

                if(index <= this.destinationsShowed) {
                    return true
                }

                return false
            }

            if(this.destinationSelected === id) {
                return true
            }

            return false

        },

    },

    computed: {

/*        destinations() {
            return this.$store.state.profile.destinations
        },*/

        contactSelectData() {
            return this.$store.state.profile.contactSelectData
        },

        contactSelectDataLength() {
            return this.contactSelectData.length
        },

        showSelectDestinations() {
            return this.destinations.length > this.showEntriesInit
        },

        showLoadMore() {

            if(this.destinationSelected !== 'all') {
                return false
            }

            let length = this.destinations.length

            if(length <= this.showEntriesInit) {
                return false
            }

            let showed = this.destinationsShowed + 1

            if(showed >= length) {
                return false
            }

            return true
        },

        showSpinner() {

            if(this.spinner === false) {
                return false
            }

            if(this.isReady === false) {
                return true
            }

            return false
        },
    }


}

